// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-content {
  background: var(--white);
}

.contact-grid {
  display: grid;
  grid-template-columns: 5fr 7fr;
  gap: 64px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.contact-title {
  font-size: 36px;
  font-weight: 700;
  color: var(--dark-color);
  margin-bottom: 16px;
}

.contact-description {
  font-size: 16px;
  line-height: 1.8;
  color: var(--text-light);
}

.info-items {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.info-item {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.info-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  flex-shrink: 0;
  box-shadow: var(--shadow-md);
}

.info-content {
  flex: 1 1;
  padding-top: 6px;
}

.info-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--dark-color);
  margin-bottom: 6px;
}

.info-text {
  font-size: 15px;
  color: var(--text-light);
  line-height: 1.6;
}

.contact-form-wrapper {
  background: var(--light-color);
  padding: 50px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--dark-color);
  margin-bottom: 8px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-color);
}

.form-input {
  padding: 14px 20px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 15px;
  font-family: var(--font-primary);
  color: var(--text-color);
  background: var(--white);
  transition: var(--transition);
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 150px;
}

.btn-block {
  width: 100%;
  justify-content: center;
}

.btn-large {
  padding: 18px 40px;
  font-size: 18px;
}

.donate-cta {
  background: var(--light-color);
}

.donate-card {
  background: var(--white);
  padding: 80px 60px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  max-width: 800px;
  margin: 0 auto;
}

.donate-title {
  font-size: 42px;
  font-weight: 700;
  color: var(--dark-color);
  margin-bottom: 20px;
}

.donate-description {
  font-size: 17px;
  line-height: 1.8;
  color: var(--text-light);
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.donate-amounts {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.amount-btn {
  padding: 16px 32px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: var(--white);
  font-size: 16px;
  font-weight: 600;
  color: var(--text-color);
  cursor: pointer;
  transition: var(--transition);
}

.amount-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
  transform: translateY(-2px);
}

.amount-btn.active {
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: var(--white);
  border-color: transparent;
}

.tax-info {
  font-size: 13px;
  color: var(--text-light);
  margin-top: 24px;
  font-style: italic;
}

@media (max-width: 968px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .contact-form-wrapper {
    padding: 40px 30px;
  }

  .donate-card {
    padding: 60px 40px;
  }

  .donate-title {
    font-size: 32px;
  }
}

@media (max-width: 640px) {
  .donate-card {
    padding: 40px 30px;
  }

  .donate-amounts {
    flex-direction: column;
  }

  .amount-btn {
    width: 100%;
  }

  .contact-form-wrapper {
    padding: 30px 24px;
  }

  .form-title {
    font-size: 24px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Contact.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,iFAAiF;EACjF,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".contact-content {\n  background: var(--white);\n}\n\n.contact-grid {\n  display: grid;\n  grid-template-columns: 5fr 7fr;\n  gap: 64px;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n}\n\n.contact-title {\n  font-size: 36px;\n  font-weight: 700;\n  color: var(--dark-color);\n  margin-bottom: 16px;\n}\n\n.contact-description {\n  font-size: 16px;\n  line-height: 1.8;\n  color: var(--text-light);\n}\n\n.info-items {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.info-item {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.info-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  flex-shrink: 0;\n  box-shadow: var(--shadow-md);\n}\n\n.info-content {\n  flex: 1;\n  padding-top: 6px;\n}\n\n.info-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--dark-color);\n  margin-bottom: 6px;\n}\n\n.info-text {\n  font-size: 15px;\n  color: var(--text-light);\n  line-height: 1.6;\n}\n\n.contact-form-wrapper {\n  background: var(--light-color);\n  padding: 50px;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.form-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--dark-color);\n  margin-bottom: 8px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n.form-input {\n  padding: 14px 20px;\n  border: 2px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  font-size: 15px;\n  font-family: var(--font-primary);\n  color: var(--text-color);\n  background: var(--white);\n  transition: var(--transition);\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 150px;\n}\n\n.btn-block {\n  width: 100%;\n  justify-content: center;\n}\n\n.btn-large {\n  padding: 18px 40px;\n  font-size: 18px;\n}\n\n.donate-cta {\n  background: var(--light-color);\n}\n\n.donate-card {\n  background: var(--white);\n  padding: 80px 60px;\n  border-radius: 20px;\n  text-align: center;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.donate-title {\n  font-size: 42px;\n  font-weight: 700;\n  color: var(--dark-color);\n  margin-bottom: 20px;\n}\n\n.donate-description {\n  font-size: 17px;\n  line-height: 1.8;\n  color: var(--text-light);\n  margin-bottom: 40px;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.donate-amounts {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n}\n\n.amount-btn {\n  padding: 16px 32px;\n  border: 2px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  background: var(--white);\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-color);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.amount-btn:hover {\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n  transform: translateY(-2px);\n}\n\n.amount-btn.active {\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\n  color: var(--white);\n  border-color: transparent;\n}\n\n.tax-info {\n  font-size: 13px;\n  color: var(--text-light);\n  margin-top: 24px;\n  font-style: italic;\n}\n\n@media (max-width: 968px) {\n  .contact-grid {\n    grid-template-columns: 1fr;\n    gap: 50px;\n  }\n\n  .contact-form-wrapper {\n    padding: 40px 30px;\n  }\n\n  .donate-card {\n    padding: 60px 40px;\n  }\n\n  .donate-title {\n    font-size: 32px;\n  }\n}\n\n@media (max-width: 640px) {\n  .donate-card {\n    padding: 40px 30px;\n  }\n\n  .donate-amounts {\n    flex-direction: column;\n  }\n\n  .amount-btn {\n    width: 100%;\n  }\n\n  .contact-form-wrapper {\n    padding: 30px 24px;\n  }\n\n  .form-title {\n    font-size: 24px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
